<template>
    <div class="notif">
        <div class="notif-icon">
            <i :class="icon" :style="style"></i>
        </div>
        <div class="notif-info">
            <span v-if="((fl_notif_cert) && (dias_expirar > 0))" class="notif-title">{{ title + ' - Certificado Digital Expirando!'}}</span>
            <span v-else-if="((fl_notif_cert) && (dias_expirar == 0))" class="notif-title">{{ title + ' - Certificado Digital Expirando Hoje!'}}</span>
            <span v-else class="notif-title">{{ title + ' - Certificado Digital Expirado!'}}</span>
            <hr>
            <div v-if="((fl_notif_cert) && (dias_expirar > 0))">
                <p>
                    O certificado digital desta empresa vence em <span class="notif-destaque">{{ dt_valid_cert }}</span>, restam <span class="notif-destaque">{{ dias_expirar }}</span> dia(s) para renovação.
                </p>
                <p>
                    Fique atento ao prazo e renove com antecedência com sua entidade certificadora e após atualize o novo certificado no cadastro da empresa para não comprometer as emissões e autorizações das notas junto à prefeitura!
                </p>
            </div>
            <div v-else-if="((fl_notif_cert) && (dias_expirar == 0))">
                <p>
                    O certificado digital desta empresa vence em <span class="notif-destaque">{{ dt_valid_cert }}</span>, restam <span class="notif-destaque">{{ dias_expirar }}</span> dia(s) para renovação.
                </p>
                <p>
                    Renove com sua entidade certificadora e após atualize o novo certificado no cadastro da empresa para que suas notas possam voltar a ser emitidas e autorizadas junto à prefeitura!
                </p>
            </div>
            <div v-else>
                <p>
                    O certificado digital desta empresa venceu em <span class="notif-destaque">{{ dt_valid_cert }}</span>.
                </p>
                <p>
                    Renove com sua entidade certificadora e após atualize o novo certificado no cadastro da empresa para que suas notas possam voltar a ser emitidas e autorizadas junto à prefeitura!
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotifCert',
    props: ['title', 'icon', 'color', 'fl_notif_cert', 'dt_valid_cert', 'dias_expirar'],
    computed: {
        style() {
            return "color: " + (this.color || "#333")
        }
    }
}
</script>

<style>
    .notif {
        flex: 1;
        display: flex;
        margin-right: 10px;
        margin-bottom: 20px;
        background-color: #cacaca;
        padding: 20px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
        border-radius: 0.25rem;                
    }

    .notif-icon {
        display: grid;
        align-items: flex-start;
        margin-top: -6px;
    }

    .notif-icon i {
        font-size: 2rem;
    }

    .notif-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .notif-title {
        font-size: 1rem;
        margin-top: -10px;        
    }

    .notif-destaque {
        font-size: 1.1rem;
        font-weight: bold;
    }

    .notif-info hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 5px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.2),
            rgba(120, 120, 120, 0.6),
            rgba(120, 120, 120, 1));
    }
</style>